import * as yup from "yup";
import { Validation } from "../../utils/validations";
import { validateCpf } from "utils/validateCpf";

export const validationSchema = yup.object({
  // garantir ser um nome completo
  fullName: yup
    .string()
    .required("Nome completo é obrigatório")
    .test("is-full-name", "Nome completo inválido", (value) => {
      const names = value?.trim().split(" ");
      return names?.length > 1;
    }),
  email: yup
    .string()
    .email("Insira um e-mail válido")
    .required("E-mail é obrigatório"),
  phoneNumber: yup
    .string()
    .test("len", "Número de telefone inválido", (value) => {
      const val_length_without_dashes = value?.replace(/\D/g, "").length;
      return val_length_without_dashes === 11;
    })
    .required("Telefone é obrigatório"),
  dateOfBirth: yup
    .string()
    .test("is-valid-date", "Data de nascimento inválida", (value) => {
      return value ? Validation.isValidDate(value) : false;
    })
    .test("is-over-18", "Você deve ter no mínimo 18 anos", (value) => {
      if (value) {
        const year = value.split("/").map(Number)[2];
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const minAgeYear = currentYear - 18;

        return year <= minAgeYear;
      }

      return false;
    })
    .required("Data de nascimento é obrigatório"),
  cpf: yup
    .string()
    .test("len", "Número do CPF inválido", (value) => validateCpf(value || ""))
    .required("Número do CPF é obrigatório"),

  password: yup.string().required(" ").min(8, " "),
  confirmPassword: yup
    .string()
    .required(" ")
    .oneOf([yup.ref("password")], "As senhas não coincidem"),
  company_token: yup.string().optional(),
});
